import { useAtom } from '@xstate/store/react';

import {
	audioPlayerState,
	closeAudioPlayer,
	openAudioPlayer,
	setIsPaused,
	setIsPlaying,
	updatePlayerState,
} from '../state/AudioPlayerState';

export const useAudioPlayerStore = () => {
	const state = useAtom(audioPlayerState);

	return {
		// State
		isOpen: state.isOpen,
		isPlaying: state.isPlaying,
		isPaused: state.isPaused,
		activeContent: state.activeContent,

		// Actions
		openAudioPlayer,
		closeAudioPlayer,
		setIsPlaying,
		setIsPaused,
		updatePlayerState,
	};
};
